import React from "react";
import { formatNumber } from "../../../lib/commonFunctions";

interface IProps {
  limit: number;
  amount: number;
  market: number;
}

const LimitLine = ({
  amount,
  limit,
  market
}: IProps) => (
  <>
    Limit: <span
    className={`${amount > limit ? "negative" : ""}`}>{formatNumber(amount)} / {formatNumber(limit)}</span>{market
      ? <><br/><span>On market: {formatNumber(market)}</span></>
      : <></>}
  </>
)

export default LimitLine;
